module.exports = __webpack_public_path__ + "static/2-3-f5085b9c287c0bb0a9d80bb8b6d211f3.png";